(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:PhasesPublic
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('PhasesPublic', PhasesPublic);

  function PhasesPublic($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/phases');
  }
}());
